 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import INTRODUCTION from '@/components/Introduction'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import TITLE_PAGE from '@/components/Title_Page'
 import BIBLE_VERSE from '@/components/Bible_Verse'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import ONE from '@/components/One'
 import TWO from '@/components/Two'
 import THREE from '@/components/Three'
 import FOUR from '@/components/Four'
 import FIVE from '@/components/Five'
 import SIX from '@/components/Six'
 import SEVEN from '@/components/Seven'
 import EIGHT from '@/components/Eight'
 import NINE from '@/components/Nine'
 import TEN from '@/components/Ten'
 import ELEVEN from '@/components/Eleven'
 import TWELVE from '@/components/Twelve'
 import THIRTEEN from '@/components/Thirteen'
 import DEAR_READER from '@/components/Dear_Reader'
 import BPALI_SUSPENSE from '@/components/BPA-LI_Suspense'
 import BPAMYREWARDS from '@/components/BPA-MyRewards'
 import EXCERPTONE from '@/components/Excerpt-one'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/One",
 			"name" : "One",
 			"component" : ONE
 		},
 		{
 			"path" : "/Two",
 			"name" : "Two",
 			"component" : TWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js